export const getTargetingStepStyle = (_, { palette }) => ({
  stepShell: {
    display: 'flex',
    flexDirection: 'column',
    '& .step-title': {
      margin: 0,
      fontWeight: 'bold',
      fontSize: 26,
      lineHeight: '36px',
    },
    '& .step-description': {
      margin: '16px 0 0 0',
      fontSize: 14,
      color: palette.neutralSecondary,
      lineHeight: '20px',
    },
    '& .collapse-panel:not(.isCollapse)': {
      '& .collapse-title-bar': {
        borderBottom: `1px solid ${palette.neutralLight}`,
      },
    },
  },
  'stepShell-s': {
    '& .step-title': {
      fontSize: 20,
      lineHeight: '26px',
    },
  },
  mainContent: {
    display: 'flex',
    alignItems: 'flex-start',
    minWidth: 300,
  },
  'mainContent-l': {
    flexDirection: 'column',
    '& .performance-tile-container': {
      position: 'static',
    },
  },
  'mainContent-m': {
    flexDirection: 'column',
    maxWidth: 480,
    '& .performance-tile-container': {
      position: 'static',
    },
  },
  'mainContent-s': {
    flexDirection: 'column',
    maxWidth: 400,
    '& .performance-tile-container': {
      position: 'absolute',
    },
  },
  estimationPart: {
    minWidth: 300,
    position: 'sticky',
    top: 24,
  },
  targetsPart: {
    marginRight: 26,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 680,
    '& .title-item': {
      width: 'auto',
      maxWidth: '100%',
    },
    '& .error-string-wrapper': {
      left: '160px',
      right: '46px',
      display: 'flex',
      '& span': {
        marginLeft: 'auto',
      },
    },
    '& .collapse-panel': {
      padding: 0,
      '& .collapse-title-bar': {
        padding: 24,
      },
      '& .helpbutton': {
        '&::before': {
          verticalAlign: 'initial',
        },
      },
      '& .collapse-content.content-show': {
        padding: '16px 24px',
      },
    },
    '& .interests': {
      '& .collapse-content.content-show': {
        overflow: 'visible',
      },
    },
    '& .audience-dimensions': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: '4px',
      margin: '8px 0',

      '& .audience-dimension': {
        alignItems: 'center',
        backgroundColor: palette.neutralLighter,
        borderRadius: 3,
        display: 'flex',
        flexDirection: 'row',
        gap: '6px',
        fontWeight: 600,
        padding: '6px 2px 6px 12px',

        '& button': {
          color: palette.neutralSecondary,
          height: 'auto',

          '& .ms-Icon': {
            fontSize: 12,
          },
        },
      },
    },
  },
  'targetsPart-l': {
    marginRight: 0,
  },
  'targetsPart-m': {
    marginRight: 0,
    width: '100%',
  },
  'targetsPart-s': {
    marginRight: 0,
    width: '100%',
  },
  'estimationPart-m': {
    width: '100%',
  },
  'estimationPart-s': {
    width: '100%',
  },

  interestsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 14,
  },

  demographicsContainer: {
    '& .alert-info .ms-Icon': {
      marginRight: 8,
    },
  },

  descriptionContainer: {
    marginBottom: '16px',

    '& .section-title': {
      marginBottom: '16px',
    },
  },

  h3LabelOptional: {
    fontSize: 14,
    color: palette.neutralSecondary,
  },

  audienceSignalDescription: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    columnGap: 12,
    fontSize: 14,

    '& > img': {
      gridRow: '1 / 3',
    },

    '& .audience-signal-main-description': {
      fontWeight: 600,
    },

    '& .audience-signal-sub-description': {
      color: palette.neutralSecondary,
    },
  },

  tooltip: {
    padding: '12px 5px',

    '& .tooltip-header': {
      paddingBottom: 8,
      borderBottom: `1px solid ${palette.neutralLight}`,
      marginBottom: 8,

      '& .interest-category': {
        fontSize: 10,
        lineHeight: '14px',
      },

      '& .interest-name': {
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '22px',
      },
    },

    '& .interest-reach': {
      fontSize: 14,
      lineHeight: '20px',

      '& span': {
        fontWeight: 600,
      },
    },
  },

  demographicsDetails: {
    '& i': {
      marginRight: 8,
    },
  },

  interestDetails: {
    display: 'flex',
    flexWrap: 'wrap',
    fontSize: 13,
    gap: '4px',

    '& .audience-interest': {
      backgroundColor: palette.neutralLighter,
      borderRadius: 4,
      padding: '4px 8px',
      wordBreak: 'break-word',
    },
  },
});
